import React from "react";

const GuidelineScreen: React.FC = () => {
  return (
    <div className=' text-gray-800 min-h-screen'>
      <div className=' mx-auto'>
        <section className='px-4 py-4  bg-white shadow-md rounded-lg'>
          <h2 className='text-xl text-gray-700 border-b pb-2 mb-4'>GUIDELINES</h2>
          <h3 className='text-md font-semibold border-b text-gray-700  pb-2 mb-2'>
            {" "}
            STEPS FOR PERFORMANCE ASSESSMENT
          </h3>
          <h3 className='text-md font-semibold text-gray-700 pb-2 mb-2'>
            Go through the employee self assessment form before scheduling the meeting with the employee and
            analyze the following.
          </h3>
          <ul className='list-disc list-inside text-gray-600 space-y-2'>
            <li>How well did an employee fulfil his/her key responsibilities?</li>
            <li>How has the employee achieved his/her objectives?</li>
            <li>What competencies did the employee demonstrate that enhanced his/her performance?</li>
            <li>What are the progress, areas of strength, and development did you see in the employee?</li>
            <li>What are the new/changed objectives for the next review period?</li>
          </ul>

          <h3 className='text-md font-semibold border-b text-gray-700  py-2 my-2'>
            STEPS FOR CONDUCTING PERFORMANCE REVIEW DISCUSSION:
          </h3>
          <h3 className='text-md font-semibold text-gray-700 pb-2 mb-2'>Conducting the Review discussion</h3>
          <ul className='list-disc list-inside text-gray-600 space-y-2'>
            <li>Create a positive environment and help the employee feel at ease.</li>
            <li>Give balanced feedback, both positive and negative, but start with the positive.</li>
            <li>Focus on the job, not the person.</li>
            <li>When discussing areas for improvement, discuss methods and objectives for improving them.</li>
            <li>
              Discuss possibilities for advancement, the employee`s aspirations, and professional development
              necessary to be a candidate for such future positions.
            </li>
          </ul>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Conclusion</h3>

          <ul className='list-disc list-inside text-gray-600 space-y-2'>
            <li>Summarize and review the important points of the discussion.</li>
            <li>
              Restate the action steps that have been recommended and provide a time frame for completion.
            </li>
            <li>Make sure the employee reviews the appraisal and provides comments.</li>
          </ul>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Follow up</h3>

          <ul className='list-disc list-inside text-gray-600 space-y-2'>
            <li>Follow up with the employee to see how the plans are proceeding.</li>
            <li>
              Offer the employee assistance in achieving objectives and encourage discussion of success and
              obstacles.
            </li>
          </ul>
          <h3 className='text-md font-semibold  text-gray-700 border-b  py-2 my-2'> RATING SCALE</h3>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Outstanding Performance (5)</h3>
          <p>
            Employee exceeds all expectations and objectives. Performance at this level is rare but possible.
          </p>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Significantly Contributes (4)</h3>
          <p>Employee meets all expectations and objectives and definitely exceeds some objectives.</p>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Meets Expectations (3)</h3>
          <p>Employee meets the expectations and objectives.</p>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Needs Improvement (2)</h3>
          <p>
            Employee`s Performance is not able to completely meet the expectations and objectives. Such
            employees need to be put under development plant and closely mentored/monitored for improving
            their performance.
          </p>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Unsatisfactory (1)</h3>
          <p>
            Employee`s Performance is below average. Such employees need to be discussed with HR and
            management and accordingly action can be taken (e.g. Performance Improvement Plan.)
          </p>

          <h3 className='text-md font-semibold text-gray-700  py-2 my-2'>Note:</h3>
          <p>
            Base your comments on the employees’ performance as a whole. Avoid being influenced by recent
            instances of special successes or failures.
          </p>
          <p>In the case of exceptionally high or low ratings, justify them with instances.</p>
          <p>Please ensure that comments are specific, avoid vague comments.</p>
        </section>

        <section className='mx-auto bg-white shadow-md rounded-lg p-6'>
          <h2 className='text-xl font-semibold text-gray-700 border-b pb-2 mb-4'>FAQs</h2>
          <h3 className='text-md font-semibold border-b text-gray-700  pb-2 mb-2'>
            Performance Management Guidelines
          </h3>

          {/* Section 1: What is Performance Management */}
          <div className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 my-2'>What is Performance Management?</h2>
            <p className='text-gray-600'>
              It is an ongoing process that links individual performance to organizational needs. It involves
              performance planning, continuous feedback, and reviewing performance. It also involves the
              development of an employee from both professional and personal aspects.
            </p>
          </div>

          {/* Section 2: Performance Management Requirements */}
          <section className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>Performance Management Requirements</h2>
            <ul className='list-disc list-inside text-gray-600 space-y-2'>
              <li>Setting Goals</li>
              <li>Reviewing Goals</li>
              <li>Reviewing Competencies</li>
              <li>Assessing performance against key responsibilities</li>
              <li>Documenting Development Plan</li>
              <li>Appraisal Outcome</li>
            </ul>
          </section>

          {/* Section 3: Goals */}
          <section className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>I. Goals</h2>
            <p className='text-gray-600 mb-4'>
              <strong>What is a Goal?</strong> Specific job assignments with specific timeframes and expected
              results. Goals must be agreed upon between the Manager and employee. They must include a
              timeframe for achievement.
            </p>
            <ul className='list-disc list-inside text-gray-600 space-y-2'>
              <li>Goals are set during the review period or within 45 days of joining (for new hires).</li>
              <li>Minimum three goals should be set.</li>
              <li>Goals should be SMART (Specific, Measurable, Achievable, Realistic, and Time-bound).</li>
            </ul>

            <h3 className='text-md font-semibold text-gray-700 mt-4'>Illustrations:</h3>
            <div className='space-y-3 space-x-2 mb-2'>
              <div className='text-gray-600 '>
                <strong>KRA:</strong> Submission of qualified leads <br />
                <strong>Measurable Goal:</strong> To submit 4 qualified leads <br />
                <strong>Timeline:</strong> By the end of every month.<br />
              
                <strong>KRA:</strong> Retention of team members <br />
                <strong>Measurable Goal:</strong> Retain valuable resources and reduce attrition to 6% <br />
                <strong>Timeline:</strong> By the end of the 3rd Quarter 2014.
              </div>
            </div>
          </section>

          {/* Section 4: Key Responsibilities */}
          <section className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>
              II. Documenting Key Responsibilities
            </h2>
            <p className='text-gray-600'>
              Recurring aspects of a job, which include day-to-day tasks and activities.
            </p>
          </section>

          {/* Section 5: Competencies */}
          <section className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>III. Competencies</h2>
            <p className='text-gray-600 mb-4'>
              <strong>What is a Competency?</strong> Skills, abilities, and other personal characteristics
              that are critical for employees to succeed in their jobs.
            </p>
            <p className='text-gray-600'>
              <strong>Distinguishing Competencies:</strong> Personal attributes are usually formed early in
              life. Skills are situational and specific to a job, whereas competencies are broad and
              universal.
            </p>
          </section>

          {/* Section 6: Development Plans */}
          <section className='mb-6'>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>IV. Development Plans</h2>
            <p className='text-gray-600 mb-4'>
              <strong>What is an Area for Development?</strong> A competency that needs to be strengthened or
              improved so that the employee can successfully perform tasks.
            </p>
            <p className='text-gray-600'>
              <strong>Illustration:</strong> Improve written communication by attending a written
              communication workshop.
            </p>
          </section>

          {/* Section 7: Appraisal Outcome */}
          <section>
            <h2 className='text-md font-semibold text-gray-700 mb-2'>V. Appraisal Outcome</h2>
            <p className='text-gray-600 mb-4'>
              <strong>Comments:</strong> Space for comments by the employee and manager, if necessary. Include
              comments on self-development, training needs, or career development.
            </p>
            <p className='text-gray-600'>
              <strong>Overall View of Performance:</strong> This is the manager`s view of the overall
              performance. Assessments must be made based on the overall ratings listed in the guidelines.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
};

export default GuidelineScreen;
